// extracted by mini-css-extract-plugin
export var numpadContainer = "_o5-1";
export var phoneButton = "_o5-0";